import React from "react";
import { Link } from "react-router-dom";

const TopSideCountBar = ({ data, loading }) => {
  return (
    <>
      {/* Left Column: 8 Metric Cards */}
      <div className="col-xl-6">
        <div className="row g-2">
          {/* Total Users */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/user/all-member">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Total Users
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading ? "Loading..." : data?.totalUsers}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded">
                        <i className="far fa-user" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Active Users */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/user/all-member?status=Active">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Active Users
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading ? "Loading..." : data?.activeUser}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded staticon2">
                        <i className="far fa-users" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Monthly New Sign Up */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/user/all-member">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Monthly New Sign Up
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading
                          ? "Loading..."
                          : data?.monthlyNewSignUp || data?.newSignUp}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded staticon3">
                        <i className="far fa-lock" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Revenue */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/transaction-history?status=Paid">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Revenue
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading ? "Loading..." : data?.revenue}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded staticon4">
                        <i className="far fa-money-bill-wave-alt" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Total Male */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/user/all-member?gender=Male">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Total Male
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading ? "Loading..." : data?.totalMale}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded staticon2">
                        <i className="fa fa-mars" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Total Female */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/user/all-member?gender=Female">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Total Female
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading ? "Loading..." : data?.totalFemale}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded staticon3">
                        <i className="fa fa-venus" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Deactive Users */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/user/all-member?status=Deactive">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Deactive Users
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading ? "Loading..." : data?.deactiveUser}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded staticon4">
                        <i className="far fa-user-slash" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Incomplete Profiles */}
          <div className="col-xl-6 col-md-6 col-sm-12">
            <div className="card custom-card overflow-hidden main-content-card mt-2">
              <Link to="/user/all-member">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center justify-content-between gap-1 flex-xxl-nowrap flex-wrap">
                    <div>
                      <span className="text-muted d-block mb-1 text-nowrap">
                        Incomplete Profiles
                      </span>
                      <h4 className="fw-medium mb-0">
                        {loading ? "Loading..." : data?.pendingProfileUser}
                      </h4>
                    </div>
                    <div className="lh-1">
                      <span className="avatar avatar-md avatar-rounded staticon1">
                        <i className="far fa-user-clock" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column: Pending Approvals */}
      <div className="col-xl-6">
        <div className="card pending-app overflow-hidden mt-2 mb-2 h-100">
          <div className="card-body p-3">
            <h4 className="mb-3">Pending Approvals</h4>
            <div className="d-lg-flex align-items-lg-center justify-content-lg-between mb-2">
              <Link to="/profile/photo-approval" className="p-2">
                <div className="d-flex align-items-center justify-content-start">
                  <img
                    src={`${process.env.PUBLIC_URL || ""}/assets/images/photoapproval.png`}
                    className="mr-2"
                    alt=""
                  />
                  <div>
                    <h5 className="pt-0 mb-1">
                      <strong>
                        {loading ? "Loading..." : data?.photoApprovalPending}
                      </strong>
                    </h5>
                    <h6 className="mb-0">Photo Approval</h6>
                  </div>
                </div>
              </Link>
              <Link to="/profile/document-approval" className="p-2">
                <div className="d-flex align-items-center justify-content-start">
                  <img
                    src={`${process.env.PUBLIC_URL || ""}/assets/images/docapproval.png`}
                    className="mr-2"
                    alt=""
                  />
                  <div>
                    <h5 className="pt-0 mb-1">
                      <strong>
                        {loading
                          ? "Loading..."
                          : data?.DocumentApprovalPending}
                      </strong>
                    </h5>
                    <h6 className="mb-0">Document Approval</h6>
                  </div>
                </div>
              </Link>
            </div>
            <div className="d-lg-flex align-items-lg-center justify-content-lg-between mb-2">
              <Link
                to="/profile/profile-approval?filter=profilePending"
                className="p-2"
              >
                <div className="d-flex align-items-center justify-content-start">
                  <img
                    src={`${process.env.PUBLIC_URL || ""}/assets/images/docapproval.png`}
                    className="mr-2"
                    alt=""
                  />
                  <div>
                    <h5 className="pt-0 mb-1">
                      <strong>
                        {loading
                          ? "Loading..."
                          : data?.profileApprovalPending}
                      </strong>
                    </h5>
                    <h6 className="mb-0">Profile Approval</h6>
                  </div>
                </div>
              </Link>
              <Link
                to="/profile/profile-approval?filter=aboutMePending"
                className="p-2"
              >
                <div className="d-flex align-items-center justify-content-start">
                  <img
                    src={`${process.env.PUBLIC_URL || ""}/assets/images/docapproval.png`}
                    className="mr-2"
                    alt=""
                  />
                  <div>
                    <h5 className="pt-0 mb-1">
                      <strong>
                        {loading ? "Loading..." : data?.totalAboutMePending}
                      </strong>
                    </h5>
                    <h6 className="mb-0">About me Approval</h6>
                  </div>
                </div>
              </Link>
            </div>
            <div className="d-lg-flex align-items-lg-center justify-content-lg-between">
              <Link
                to="/profile/profile-approval?filter=genderPending"
                className="p-2"
              >
                <div className="d-flex align-items-center justify-content-start">
                  <img
                    src={`${process.env.PUBLIC_URL || ""}/assets/images/docapproval.png`}
                    className="mr-2"
                    alt=""
                  />
                  <div>
                    <h5 className="pt-0 mb-1">
                      <strong>
                        {loading ? "Loading..." : data?.totalGenderPending}
                      </strong>
                    </h5>
                    <h6 className="mb-0">Gender Approval</h6>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopSideCountBar;